import { generatePath } from 'react-router-dom';
import { ApiRoutes, GetUserProfileResponse, GetUsersListResponse, UpdateUserProfileRequest } from 'types';
import { axiosInstance } from './axiosInstance';
import { getApiUrl } from './helpers';

export async function fetchUserProfile() {
  const path = generatePath(ApiRoutes.UserProfile);
  const { data } = await axiosInstance.get<GetUserProfileResponse>(getApiUrl({ path }));
  return data;
}

export async function fetchUsersList() {
  const path = generatePath(ApiRoutes.UsersList);
  const { data } = await axiosInstance.get<GetUsersListResponse>(getApiUrl({ path }));
  return data;
}

export async function updateUserProfile(payload: UpdateUserProfileRequest) {
  const path = generatePath(ApiRoutes.UserProfile);
  const { data } = await axiosInstance.put(getApiUrl({ path }), payload);
  return data;
}
